import { useEffect, useRef, useState } from 'react';

import clsx from 'clsx';

import countriesData from './utils/countryData';
import styles from './styles.module.scss';
import useTranslation from 'hooks/useTranslation';
import CountryDialCodeSelect from './components/CountryDialCodeSelect';

// TODO: add mask formating phone number regarding each country
function InternationalMobileNumInput({
  onChangeInput,
  value,
  error,
  prefix,
  customClass,
  clickHandlerProp,
}) {
  const { getTranslation, getAppLocale } = useTranslation('AUTH');
  const { t } = getTranslation();
  const locale = getAppLocale();

  const defaultCode = locale === 'fa' ? 'ir' : 'ae';
  const [selectedCountryCode, setSelectedCountryCode] = useState(defaultCode);

  const mobileInputRef = useRef(null);

  const getFormatedDialCode = (dialCode) => `${prefix}${dialCode}`;

  const getParsedCountry = (country) => {
    const [countryName, countryCode, dialCode] = country;

    return {
      value: countryCode,
      countryName,
      dialCode,
    };
  };

  const getCountryByCountryCode = (code) => {
    const country = countriesData.find((item) => item[1] === code);

    return getParsedCountry(country);
  };

  const guessCountryByPartialNumber = (number) => {
    const country = countriesData.find((item) => {
      const dialCode = item[2];

      return number?.startsWith(`+${dialCode}`);
    });

    if (!country || country[1] === selectedCountryCode) return;

    return getParsedCountry(country);
  };

  const handleChangeCountry = (option, clearPhoneInput = true) => {
    setSelectedCountryCode(option.value);

    if (!clearPhoneInput) return;

    onChangeInput(getFormatedDialCode(option.dialCode));
  };

  const handleChangeCountrySelect = (option) => {
    handleChangeCountry(option);

    mobileInputRef?.current?.focus();
  };

  const handleChangeMobileNumInput = (e) => {
    const { value } = e.target;

    onChangeInput(value);

    // do not proceed guessing country process if value is more than 5 digits
    if (value.length > 5) return;

    const guessedCountry = guessCountryByPartialNumber(value);

    if (guessedCountry) {
      handleChangeCountry(guessedCountry, false);
    }
  };

  useEffect(() => {
    // add default dial code at the beggining if input is empty
    if (!value) {
      handleChangeCountry(getCountryByCountryCode(defaultCode));
      return;
    }
  }, []);

  return (
    <div className={`${styles.phone_num_input} ${customClass}`}>
      <div className='flex'>
        <CountryDialCodeSelect
          onChange={handleChangeCountrySelect}
          selectedCountryCode={selectedCountryCode}
          className={styles.country_select}
        />
        <input
          type='tel'
          ref={mobileInputRef}
          value={value}
          onChange={handleChangeMobileNumInput}
          className={clsx([error && 'has-error', styles.input])}
          placeholder={t('WITH_COUNTRY_MOBILE_PLACEHOLDER')}
          onClick={clickHandlerProp}
        />
      </div>
    </div>
  );
}

InternationalMobileNumInput.defaultProps = {
  prefix: '+',
};

export default InternationalMobileNumInput;
